import React, { useEffect, useRef, useState } from 'react';
import data from './data/impressum.json';
import ReactMarkdown from 'react-markdown';
import AdvancedMarkdownRenderer from './AdvancedMarkdownRender';
import { useNavigate } from 'react-router-dom';

const Impressum = () => {
    const navigate = useNavigate();

    return (
        <div className='w-full text-900'>
            <div className='flex flex-column m-auto w-full p-3 pt-3 pb-6 lg:w-7'>
                <div>
                    <h1>Impressum</h1>
                    <AdvancedMarkdownRenderer content={data.content} />
                </div>
            </div>
        </div>
    );
};

export default Impressum;
